import React from 'react'

import { connect as connectRedux } from 'react-redux'
import { Map, List } from 'immutable'
import compose from 'recompose/compose'

import { REMOVED_ROWS_SETTINGS } from '../../../services/url/constants'
import { getBoundActions } from '../../../actions/index'
import IconV2, { ICON_TYPES } from '../../Icon.v2/index'
import Expandable from '../../Expandable/Expandable'
import FeedbackBox, { FEEDBACK_BOX_TYPES } from '../../FeedbackBox/index'
import StaticTextToHtml from '../../StaticTextToHtml/index'

import useRemovedRowsSettings from './useRemovedRowsSettings'

const RemovedRowsSettings = ({
  removedRowsIds,
  pmSection,
  staticText,
  getMultiplePmSections,
  setFeatureTrackingDataPersistent,
}) => {
  const { removedRows, hideRow, addRowBack } = useRemovedRowsSettings(
    removedRowsIds,
    pmSection,
    getMultiplePmSections,
    setFeatureTrackingDataPersistent,
  )

  if (!removedRows.size) {
    return null
  }

  return (
    <Expandable
      id={REMOVED_ROWS_SETTINGS}
      variant="setting"
      header={staticText.getIn(['data', 'removedRows'])}
      description={() => (
        <StaticTextToHtml staticText={staticText} staticTextKey={['data', 'removedRowsDescription']} />
      )}
    >
      {removedRows.count() > 0 ? (
        <React.Fragment>
          <div className="content-preferences__intro content-preferences__item">
            <div className="content-preferences__label-container">
              <p className="content-preferences__space-holder" />
              <p className="content-preferences__space-holder" />
              <p className="content-preferences__cta">{staticText.getIn(['data', 'addItBack'])}</p>
            </div>
          </div>
          <ul className="no-border-bottom-on-last-child">
            {removedRows.valueSeq().map((item) => {
              const id = item.getIn(['data', 'id'])
              const title = item.getIn(['data', 'data', 'header', 'label'])
              const addedBack = item.get('addedBack')
              return (
                <li key={id} className="content-preferences__item">
                  <div className="content-preferences__item--wrapper">
                    <p><strong>{title}</strong></p>
                  </div>
                  <p className="content-preferences__title content-preferences__item-title">
                    {title}
                  </p>
                  { addedBack
                    ? <IconV2
                      type={ICON_TYPES.CIRCULAR_CHECK}
                      onClick={() => hideRow(item)}
                    />
                    : <IconV2
                      type={ICON_TYPES.CIRCULAR_ADD}
                      onClick={() => addRowBack(item)}
                    />
                  }
                </li>
              )
            })}
          </ul>
        </React.Fragment>
      ) : (
        <FeedbackBox type={FEEDBACK_BOX_TYPES.INFO}>
          <StaticTextToHtml staticText={staticText} staticTextKey={['data', 'emptyMessageRemovedRows']} />
        </FeedbackBox>
      )}
    </Expandable>
  )
}

export default compose(
  connectRedux(
    (state) => {
      return {
        removedRowsIds: state.featureTracking.getIn(['data', 'hiddenPmSectionIds']) || List(),
        pmSection: state.pmSection || Map(),
        staticText: state.staticText.getIn(['data', 'myAccountContentPreferencesPage'], Map()),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        getMultiplePmSections: actions.pmSection.getMultiplePmSections,
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
      }
    },
  ),
)(RemovedRowsSettings)
